import * as zExt from "@redotech/rpc/ext";
import * as z from "zod";

export const resetWmsSot = {
  name: "resetWmsSot" as const,
  input: z.object({ teamId: zExt.objectId() }),
  output: z.object({ success: z.boolean(), workflowId: z.string() }),
  description: "Reset all WMS SOT onboarding data for a team",
};
